import { ListItem } from '@jisr-hr/ds-beta'
import { memo } from 'react'
import { ListItemPropsT } from './helper'

const MemoizedListItem = ({ title, value, onClick }: ListItemPropsT) => {
  return (
    <ListItem
      key={title}
      text={title}
      value={String(value)}
      onClick={onClick}
    />
  )
}

export default memo(MemoizedListItem)
